<template>
    <div>
            <!-- breadcrumb-area -->
            <section class="breadcrumb__area breadcrumb__bg">
                <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100" data-background="/assets/img/bg/breadcrumb_bg.jpg"></div>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="breadcrumb__content">
                                <h2 class="title">{{ $route.name }}</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="breadcrumb__shape">
                    <img src="/assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
                    <img src="/assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
                    <img src="/assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
                    <img src="/assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
                    <img src="/assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
                </div>
            </section>
            <!-- breadcrumb-area-end -->
            <!-- blog-area -->
            <section class="">
                <div class="container">
                    <div class="blog__inner-wrap">
                        <div class="row">

                            <div class="col-md-70 mb-20" >
                                <input v-model="cari" class="form-control" @keyup="fetchBerita" placeholder="Pencarian">
                            </div>

                            <div class="col-70">
                                <div class="blog-post-wrap">
                                    <div class="row gutter-24">
                                        
                                        <div class="col-md-6" v-for="(item, index) in listData" :key="index">
                                            <div class="blog__post-two shine-animate-item">
                                                <div class="blog__post-thumb-two">
                                                    <a href="javascript:void(0)" class="shine-animate"><img :src="$store.state.UPLOADS+item.foto" alt="Apexa" /></a>
                                                </div>
                                                <div class="blog__post-content-two">
                                                    <div class="blog-post-meta">
                                                        <ul class="list-wrap"> 
                                                            <li style="font-size: 12pt;"><i class="fas fa-calendar-alt"></i>{{UMUM.tglConvert(item.createAt).tgl}}</li>
                                                        </ul>
                                                    </div>
                                                    <h2 class="title" style="font-size: 12pt;"><a href="javascript:void(0)" @click="routerKe('/Beritaisi/'+item.id)">{{item.judul}}</a></h2>
                                                    <div class="blog-avatar">
                            
                                                        <div class="avatar-content">
                                                            <p style="font-size: 10pt;">👤 <a href="javascript:void(0)">{{item.createBy}}</a></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    <div class="pagination-wrap mt-40 mb-40">
                                        <nav aria-label="Page navigation example">
                                            <ul class="pagination list-wrap">
                                                <li class="page-item">
                                                    <a class="page-link" @click="prevPage"  :disabled="currentPage === 1"><i class="fas fa-angle-double-left"></i></a>
                                                </li>
                                                <li class="page-item active"><a class="page-link"  >{{data_ke}}</a></li> 
                                                <li class="page-item"><a class="page-link"  >-</a></li>  
                                                <li class="page-item active"><a class="page-link"  >{{jml_data}}</a></li> 
                                                <li class="page-item next-page">
                                                    <a class="page-link" @click="nextPage" :disabled="currentPage === totalPages"><i class="fas fa-angle-double-right"></i></a>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>

                <sidecontentnews></sidecontentnews>

                        </div>
                    </div>
                </div>
            </section>
            <!-- blog-area-end -->
       
    </div>
</template>

<script>

import UMUM from '../library/umum';
export default {
    data() {
        return {
            UMUM:UMUM,
            cari : "",
            data_ke : 1, 
            unit_kerja :  "PYRiCmEdcQZdYxrhe",
            jml_data :  0,
            listData:[],
        }
    },
    methods: {

    fetchBerita() {
      // Ganti dengan URL API yang sesuai
        fetch('https://server-web.konaweselatankab.go.id/api/v1/web_publish_berita/viewOPD', {
            method: "POST",
            headers: {
            "content-type": "application/json", 
            }, 
            body:JSON.stringify({
            cari_value : this.cari,
            data_ke : this.data_ke, 
            unit_kerja :  this.unit_kerja
            })
        })
        .then(res => res.json())
        .then(res_data => { 
            this.listData = res_data.data  
            this.jml_data = res_data.jml_data  
            console.log(this.listData);
            
        });     
    },


    // PAGINASI
    nextPage() {
        if (this.data_ke < this.jml_data) {
            this.data_ke++;
        }
    },
    
    prevPage() {
        if (this.data_ke > 1) {
            this.data_ke--;
        }
    },
    routerKe(data) {
        this.$router.push(data)
    },
        
    },
    mounted() {
        this.fetchBerita()
    },
}
</script>